/* VENA — block-driven announcement rotator */
(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-vena-announcement-root]';

  function initialiseAnnouncement(root) {
    if (!root || root.dataset.venaAnnouncementReady === 'true') return;
    root.dataset.venaAnnouncementReady = 'true';

    const viewport = root.querySelector('[data-vena-announcement-viewport]');
    const slides = [...root.querySelectorAll('[data-vena-announcement-slide]')];
    const rotateEnabled = root.dataset.rotate === 'true';
    const delay = Number(root.dataset.rotationDelay || 5000);
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;

    if (!viewport || !slides.length) return;

    function setActive(index) {
      const nextIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      const activeSlide = slides[nextIndex];
      const height = activeSlide.dataset.announcementHeight;
      if (height) viewport.style.setProperty('--vena-announcement-height', `${height}px`);
      activeIndex = nextIndex;
    }

    function stopRotation() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function startRotation() {
      stopRotation();
      if (!rotateEnabled || slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => setActive(activeIndex + 1), delay);
    }

    root.addEventListener('mouseenter', stopRotation);
    root.addEventListener('mouseleave', startRotation);
    root.addEventListener('focusin', stopRotation);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) startRotation();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopRotation();
      else startRotation();
    });

    setActive(activeIndex);
    startRotation();
  }

  function initialiseAll(scope = document) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initialiseAnnouncement(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initialiseAnnouncement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(document), { once: true });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(ROOT_SELECTOR);
    const selectedSlide = event.target.closest('[data-vena-announcement-slide]');
    if (!root || !selectedSlide) return;

    root.querySelectorAll('[data-vena-announcement-slide]').forEach((slide) => {
      const active = slide === selectedSlide;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    const viewport = root.querySelector('[data-vena-announcement-viewport]');
    if (viewport && selectedSlide.dataset.announcementHeight) {
      viewport.style.setProperty('--vena-announcement-height', `${selectedSlide.dataset.announcementHeight}px`);
    }
  });
})();
